const emotionTexts = document.querySelectorAll('.js-emotion-text')

const init = function() {

  if ( emotionTexts ) {
    emotionTexts.forEach( rotator => {
      setupRotator( rotator )
    } )
  }

};


const setupRotator = function( rotator ) {

  const speed = rotator.getAttribute('data-emotions-speed') ? rotator.getAttribute('data-emotions-speed') : 1700
  const emotionTextItems = rotator.querySelectorAll('.js-emotion-text-item')
  let emotionImages = rotator.querySelectorAll('.js-emotion-text-images picture')
  let images = null

  // setup image rotation
  if ( emotionTextItems.length && emotionImages.length ) {

    const pageSection = document.querySelector('.js-emotion-text-images').closest('.acf-block-page-section')
    const pageSectionBackgroundContainer = pageSection.querySelector('.acf-block-page-section__background')
    const originalBackground = pageSection.querySelector( '.acf-block-page-section__background-image' )
    let   originalBackgroundClasses = null

    if ( originalBackground ) {
      originalBackgroundClasses = originalBackground.getAttribute('class')
      const find = [ 'object-position-center', 'object-position-left', 'object-position-right' ]
      find.forEach( posClass => {
        originalBackgroundClasses = originalBackgroundClasses.replace( posClass, '' )
      } )
    }

    if ( pageSectionBackgroundContainer && originalBackgroundClasses ) {

      emotionImages = [...emotionImages]
      emotionImages.reverse()

      emotionImages.forEach( picture => {
        const img = picture.querySelector('img')
        img.setAttribute( 'class', img.getAttribute('class') + ' ' + originalBackgroundClasses )
        pageSectionBackgroundContainer.prepend( picture )
      } )

      pageSectionBackgroundContainer.classList.add( 'has-emotion-rotation' )
      images = pageSectionBackgroundContainer.querySelectorAll( 'picture' );
      images[0].classList.add('is-visible')

    }

  }

  // setup text rotation
  if ( emotionTexts.length ) {
    emotionTexts.forEach( list => {
      
      const items = list.querySelectorAll('.js-emotion-text-item')
      let index = 1
      
      setInterval(() => {

        items.forEach( item => {
          item.classList.remove('is-visible')
        } )

        items[index].classList.add('is-visible')

        if ( images ) {
          images.forEach( item => {
            item.classList.remove('is-visible')
          } )
          images[index].classList.add('is-visible')
        }
        
        index = ( index === items.length - 1 ) ? 0 : index + 1

      }, speed )

    } );
  }
  
}

const api = {
	init: init
};

export default api;